export { validateNamespaces, resolveBindings } from "@cogo/runtime-v2"
